export default "__VITE_ASSET__kBXkbJPl__"